// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1___872628248378ecdd729","cls2":"mentions_milestone_ping-cls2___98bd7cfab773d19e352 mentions_milestone_ping-cls1___872628248378ecdd729"};